import {
  v2black,
  v2blue400,
  v2blue500,
  v2neutral300,
  v2white,
} from '@paypalcorp/pp-react'
import {
  greyBackgroundAndSmaller,
  mobileAndSmaller,
} from 'lib/styles/media-queries'
import { StyleSheet } from '../paypalphrodite'
import glamorous from 'glamorous'

export const BOX_BORDER_STYLES = {
  border: `1px solid ${v2neutral300}`,
  borderRadius: '0.875rem',
  [greyBackgroundAndSmaller]: {
    border: 'none',
    borderRadius: 0,
  },
}

export const PRIMARY_TEXT_FONT_FAMILY = {
  fontFamily: 'PayPalSansBig-Regular, "Helvetica Neue", Arial, sans-serif',
}

export const LINK_STYLES = {
  '&:hover': {
    color: v2blue500,
  },
  color: v2blue400,
  fontFamily: 'PayPalSansBig-Medium, "Helvetica Neue", Arial, sans-serif',
}

export const CardStyles = StyleSheet.create({
  container: {
    width: '100%',
    color: v2black,
    backgroundColor: v2white,
    lineHeight: 'normal',
    '-webkit-text-stroke-width': 'unset',
    border: 'none',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginBottom: '16px',
    padding: 0,
    maxWidth: 500,
  },
  headingText: {
    textAlign: 'center',
    marginBottom: '24px',
  },
  bodyText: {
    padding: '8px 16px',
    textAlign: 'left',
    [mobileAndSmaller]: {
      padding: '0px',
    },
  },
})

export const ButtonWrapper = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  margin: '24px 0',
})
